var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "col-2" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info btn-right",
            attrs: { id: "backBtn", type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v("キャンセルする")]
        ),
      ]),
      _c("div", { staticClass: "col-2" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-info btn btn-block",
            on: { click: _vm.sort },
          },
          [_vm._v("表示順を確定する")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "main" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-7" }, [
        _c(
          "table",
          { staticClass: "table table-dark table-sm table-hover" },
          [
            _c("thead", [
              _c("tr", [
                _c("th", {
                  staticStyle: { width: "50px" },
                  attrs: { scope: "col" },
                }),
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.isHierarchyGroupEnabled ? "第一階層" : "グループ名"
                    )
                  ),
                ]),
                _c(
                  "th",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isHierarchyGroupEnabled,
                        expression: "isHierarchyGroupEnabled",
                      },
                    ],
                    attrs: { scope: "col" },
                  },
                  [_vm._v("第二階層")]
                ),
              ]),
            ]),
            _c(
              "draggable",
              {
                attrs: {
                  tag: "tbody",
                  animation: "200",
                  "scroll-sensitivity": "500",
                },
                model: {
                  value: _vm.groups,
                  callback: function ($$v) {
                    _vm.groups = $$v
                  },
                  expression: "groups",
                },
              },
              _vm._l(_vm.groups, function (group) {
                return _c("tr", { key: group.id }, [
                  _c("td", { attrs: { align: "center" } }, [_vm._v("≡")]),
                  _c("td", [_vm._v(_vm._s(group.displayName))]),
                  _c(
                    "td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isHierarchyGroupEnabled,
                          expression: "isHierarchyGroupEnabled",
                        },
                      ],
                    },
                    [
                      _c(
                        "table",
                        [
                          _c(
                            "draggable",
                            {
                              attrs: {
                                tag: "tbody",
                                animation: "200",
                                "scroll-sensitivity": "500",
                              },
                              model: {
                                value: group.child,
                                callback: function ($$v) {
                                  _vm.$set(group, "child", $$v)
                                },
                                expression: "group.child",
                              },
                            },
                            _vm._l(group.child, function (child) {
                              return _c("tr", { key: child.id }, [
                                _c("td", { attrs: { align: "center" } }, [
                                  _vm._v("≡"),
                                ]),
                                _c("td", [_vm._v(_vm._s(child.displayName))]),
                              ])
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col-4" }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("h5", [_vm._v("連絡先グループ表示順")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }